export enum ShippingAutomationRuleType {
  AmountAutomation,
  ShippingAutomation,
  PackagesAutomation,
  MixCategoriesAutomation,
}
